import { connect } from 'react-redux'

import { selectViewedArticleRatioGauge } from 'ducks/reports/gauges'
import { PercentGauge } from 'ducks/reports/visualizations'

const staticSelect = {
  scale: { y: 'percent' },
  title: 'Viewed an Article',
  trafficLight: true,
}
const select = (state, props) => ({
  ...staticSelect,
  gauge: selectViewedArticleRatioGauge(state, props),
})
export default connect(select)(PercentGauge)
